import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-responsive-landing",
  templateUrl: "./responsive-landing.component.html",
})
export class ResponsiveLandingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  public handleAddressChange(address) {}
}
